// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__20Hsy","footer":"ModalCreateQualiphyProcedure_footer__V6WdR","additionData":"ModalCreateQualiphyProcedure_additionData__365V-"};